import * as React from 'react';

export default function Divider(props) {
    return (
        <div style={{height:0, width:'100%', border:'1px dashed #D6D6D6', marginBlock:20, ...props.style}}/>
    );
}
